/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `DirectionsWalkIconProps` interface defines the properties for the DirectionsWalkIcon component.
 */
interface DirectionsWalkIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "directions_walk" — outlined, weight 300.
 * Walking figure icon for the Spaziergänge (strolls) category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const DirectionsWalkIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'DirectionsWalkIcon',
    width
}: DirectionsWalkIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m293.08-50 114.69-570.92-95.08 38v132.53h-60v-171.84l189.69-80.62q14-6 27.97-7.19 13.96-1.19 26.8 2.66 12.85 3.84 23.81 11.88 10.96 8.04 18.58 20.89l33.84 53.99q29.85 48.54 75.12 78.04 45.27 29.5 101.5 31.81v60q-68.46-3.08-122.12-34.77-53.65-31.69-92.27-83.62l-30.76 153.01L590-330.77V-50h-60v-247.31l-97.85-83.61L355.54-50h-62.46Zm194.65-717.73q-21.58-21.58-21.58-52.27 0-30.69 21.58-52.27 21.58-21.58 52.27-21.58 30.69 0 52.27 21.58 21.58 21.58 21.58 52.27 0 30.69-21.58 52.27-21.58 21.58-52.27 21.58-30.69 0-52.27-21.58Z" />
    </svg>
);

DirectionsWalkIcon.displayName = 'DirectionsWalkIcon';